<ng-container *ngIf="listOfDepartments">
  <div class="department-filter-component">
    <fieldset class="department-names" *ngIf="listOfDepartments.length">
      <label *ngFor="let department of listOfDepartments" class="radio">
        <span class="radio__input">
          <input
            type="radio"
            [checked]="department.code === selectedDepartment"
            (change)="handleRadioChange($event)"
            id="{{ department.code }}"
          />
          <span class="radio__control"></span>
        </span>
        <span class="radio__label">
          {{ department.code }}
        </span>
      </label>
    </fieldset>
    <app-date-quick-chips
      [activeKey]="activeChip"
      (rangeSelected)="onQuickRange($event)"
    ></app-date-quick-chips>
    <mat-form-field appearance="outline">
      <mat-label>Start date</mat-label>
      <input matInput [matDatepicker]="start" [formControl]="startDate" />
      <mat-datepicker-toggle matSuffix [for]="start"></mat-datepicker-toggle>
      <mat-datepicker #start></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>End date</mat-label>
      <input matInput [matDatepicker]="end" [formControl]="endDate" />
      <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
      <mat-datepicker #end></mat-datepicker>
    </mat-form-field>
    <button
      mat-stroked-button
      class="apply-department-filter"
      (click)="handleFilterByDateChanged()"
      [disabled]="disabled"
    >
      Apply
    </button>
  </div>
</ng-container>
